import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import CardInformationContainer from "../../../Components/Cards/Information/container";
import { API_BASE_URL } from "../../../config/api";
import { ErrorState, Skeleton } from "../../../Components/AsyncState";
export default function CardContainer() {
  const [statsData, setStatsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const fetchStatsData = async () => {
    setLoading(true); setError("");
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/auth/admin/user-stats/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try to refresh
      if (response.status === 401) {
        try {
          const refreshResponse = await fetch(
            `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                refresh: localStorage.getItem("refresh"),
              }),
            },
          );

          if (!refreshResponse.ok) {
            // refresh failed → log out and redirect
            localStorage.removeItem("access");
            localStorage.removeItem("authCredentials");
            localStorage.removeItem("refresh");
            localStorage.removeItem("role");
            localStorage.removeItem("email");
            window.location.href = "/signin";
            return; // ⬅️ IMPORTANT: stop here
          }

          const refreshData = await refreshResponse.json();
          localStorage.setItem("access", refreshData.access);

          // retry original request with new access token
          response = await fetch(
            `${API_BASE_URL}/api/v0/auth/admin/user-stats/`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("access")}`,
              },
            },
          );
        } catch (err) {
          console.error("Error refreshing token:", err);
          return;
        }
      }

      // handle final response (original or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Stats Data:", data);
      setStatsData(data);
    } catch (error) {
      console.error("Error fetching stats data:", error);
      setError("خطا در دریافت آمار کاربران");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatsData();
  }, []);
  return (
    <div className="w-full h-fit bg-zi-bg2-light dark:bg-zi-bg2-dark rounded-2xl p-5">
      {error && <ErrorState message={error} onRetry={fetchStatsData} />}
      {loading && <div className="grid w-full grid-cols-1 gap-5 md:grid-cols-3"><Skeleton className="h-[150px] w-full" rounded="lg" /><Skeleton className="h-[150px] w-full" rounded="lg" /><Skeleton className="h-[150px] w-full" rounded="lg" /></div>}
      {!loading && !error && (
      <div className="flex items-center gap-10 justify-evenly overflow-x-auto">
        <CardInformationContainer
          color="blue"
          width="300px"
          title="تعداد کل کاربران"
          value={statsData ? statsData.all_users : "-"}
          data=""
          button={false}
          buttonText="خرید چالش جدید"
          svgName="userManage"
          svgClassName="stroke-white"
          // accLoading={accLoading}
        />
        <CardInformationContainer
          color="green"
          width="300px"
          title="تعداد کاربران دارای چالش فعال"
          value={statsData ? statsData.all_users_with_challenge : "-"}
          link={false}
          data=""
          button={false}
          valueLtr={true}
          buttonText="برداشت سود"
          svgName="managers"
          svgClassName="stroke-white"
          // accLoading={accLoading}
        />

        <CardInformationContainer
          color="yellow"
          width="300px"
          title="تعداد کاربران فاند شده"
          value={statsData ? statsData.all_funded_users : "-"}
          valueLtr={true}
          link={false}
          data=""
          button={false}
          buttonText="دعوت از دوستان"
          svgName="friend"
          svgClassName=""
          // accLoading={accLoading}
        />
      </div>
      )}
    </div>
  );
}
